// latest: zhangmyh 2017-6-22 1:31 AM
import collection from 'collection/bank'
import uMessage from 'components/message'
import './index.less'
/* global $ ko u */

let _config
function init (refer) {
  let bankType = [
    { id: 0, value: 'hot', text: '热门银行' },
    { id: 1, value: 'A,B,C,D,E,F', text: 'ABCDEF' },
    { id: 2, value: 'G,H,I,J', text: 'GHIJ' },
    { id: 3, value: 'K,L,M,N', text: 'KLMN' },
    { id: 4, value: 'O,P,Q,R,S,T', text: 'OPQRST' },
    { id: 5, value: 'U,V,W,X,Y,Z', text: 'UVWXYZ' }
  ]
  let selectedNode = null
  let isForeign = (_config.inPRC) ? 0 : 1
  collection.load({
    bankStatus: 1,
    isHot: 1,
    bankInitial: '',
    isForeign
  })

  let vm = {
    index: ko.observable(0),
    navList: bankType,
    changeInitial: function (index) {
      let params = { isForeign }
      if (index == 0) {
        params.isHot = 1
        params.bankInitial = ''
      } else {
        params.isHot = ''
        params.bankInitial = bankType[index].value
      }
      params.bankStatus = 1
      collection.load(params)
      this.index(index)
    },
    chooseNode: function (row) {
      selectedNode = row.getSimpleData()
      refer.submit()
    },
    model: collection.datatable
  }
  let app = u.createApp()
  app.init(vm, $('#bank_refer')[0])
  refer.registerSubmitFunc(() => {
    if (!selectedNode) {
      uMessage('warning', '请选择银行')
    }
    return selectedNode
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    inPRC: true,
    repeatable: true,
    multiSelect: false
  }, config)
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/bank/index.js